import { Children, cloneElement, useContext, useState } from 'react';

import { usePositionsGetQuery } from '../../Common/Queries/positionsQueries';

import { AuthContext } from '../../constants';

export function MyOpenPositionsContainer({ children, isTotalPositions }) {
  const { userInfo } = useContext(AuthContext);
  const child = Children.only(children);
  const [filters, setFilters] = useState({ searchValue: '', page: 0 });
  const [limit, setLimit] = useState(20);

  const queryParams = {
    status: 'ACTIVE',
    page: filters.page + 1,
    limit,
    q: filters.searchValue.length >= 2 ? filters.searchValue : '',
  };

  if (!isTotalPositions) {
    queryParams.userID = userInfo?.entityID;
  }

  const positions = usePositionsGetQuery(queryParams);

  const handleFilterChange = (updatedFilters) => {
    setFilters((prev) => ({ ...prev, ...updatedFilters }));
  };

  return cloneElement(child, {
    positions,
    isTotalPositions,
    filters,
    filterHandler: handleFilterChange,
    limit,
    setLimit,
  });
}
